<template>
  <div>
    <div class="my-2 font-weight-bold">
      {{ title }}
    </div>

    <div class="progres-bar mb-1 pa-0">
      <div class="mr-2">
        {{ t("locations_progress.ProgressBar_Time") }}
      </div>
      <div class="progress">
        <div
          class="bar"
          :style="{ width: percentCalendar + '%', backgroundColor: '#0093E5' }"
        >
          <div class="progress-value"></div>
        </div>
      </div>
      <div class="percent" :style="{ color: '#0093E5' }">
        {{ percentCalendar.toFixed(2) + "%" }}
      </div>
    </div>

    <div class="progres-bar mb-1">
      <div class="mr-2">
        {{ t("locations_progress.ProgressBar_Progress") }}
      </div>
      <div class="progress">
        <div
          class="bar"
          :style="{
            width: percentConstruction + '%',
            backgroundColor: '#FFB800',
          }"
        >
          <div class="progress-value"></div>
        </div>
      </div>
      <div class="percent" :style="{ color: '#FFB800' }">
        {{ percentConstruction.toFixed(2) + "%" }}
      </div>
    </div>

    <div class="progres-bar mb-4">
      <div class="mr-2">
        {{ t("locations_progress.ProgressBar_Delay") }}
      </div>
      <div class="progress">
        <div
          class="bar"
          :style="{ width: percentBarrier + '%', backgroundColor: '#FF0000' }"
        >
          <div class="progress-value"></div>
        </div>
      </div>
      <div class="percent" :style="{ color: '#FF0000' }">
        {{ percentBarrier.toFixed(2) + "%" }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
defineProps({
  title: String,
  percentCalendar: Number,
  percentConstruction: Number,
  percentBarrier: Number,
});
</script>

<style scoped>
.progres-bar,
.card,
.progress {
  display: flex;
  justify-content: end;
  font-size: 8px;
}

.progres-bar {
  align-items: center;
}

.progress {
  width: 7em;
  height: 10px;
  border-radius: 5px;
  padding: 2px;
  align-items: center;
  background: white;
  justify-content: start;
  min-width: 70px;
}

.progress .bar {
  width: var(--progress);
  height: 100%;
  border-radius: 5px;
  text-align: end;
}
.percent {
  margin-left: 0px;
  text-align: end;
  min-width: 35px;
}
</style>
